import {Component, OnInit} from '@angular/core';
import {firstValueFrom, Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {User} from 'src/app/models/User';
import {SharedService} from 'src/app/services/shared.service';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Project} from 'src/app/models/Project';
import {SortService} from 'src/app/services/sort.service';
import {NewProjectComponent} from './new-project/new-project.component';
import {AuthService} from 'src/app/services/auth.service';
import {MediaMatcher} from '@angular/cdk/layout';
import {environment} from 'src/environments/environment';
import {NavigationEnd, Router} from '@angular/router';
import {EmailService} from 'src/app/services/email.service';
import {CurrentpathService} from 'src/app/services/currentpath.service';
import {GlobalService} from 'src/app/services/global.service';
import {PopupService} from 'src/app/services/popup.service';
import {IdService} from 'src/app/services/id.service';
import {UserService} from 'src/app/services/user.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css'],
})
export class ProjectsComponent implements OnInit {
  allProjects: Project[];
  projectsFrontend: Project[] = [];
  user: User;
  projectid: string;
  isAdmin = false;
  page = '';
  path: string;
  pathsplit: string[];
  mobileQuery: MediaQueryList;
  mobileQueryLogo: MediaQueryList;
  isFieldScan: boolean;
  isFieldScanRoot: boolean;
  navbarVisible = true;
  private ngUnsubscribe = new Subject();

  constructor(
    private sharedservice: SharedService,
    private dialogNewProject: MatDialog,
    private sortservice: SortService,
    private authservice: AuthService,
    media: MediaMatcher,
    private router: Router,
    private currentpathservice: CurrentpathService,
    private emailservice: EmailService,
    private globalservice: GlobalService,
    private popupservice: PopupService,
    private idservice: IdService,
    private userservice: UserService
  ) {
    this.mobileQuery = media.matchMedia(environment.mobileQueryMaxwidthSmall);
    this.mobileQueryLogo = media.matchMedia(
      environment.mobileQueryMaxwidthExtraSmall
    );
  }

  async pathHelper(pathsplit: string[]) {
    this.projectid = this.idservice.projectId();
    this.isFieldScan = this.idservice.isFieldScanPath();
    this.isFieldScanRoot = this.idservice.isFieldScanRootPath();
    this.pathsplit = pathsplit;
    if (this.user?.role?.name === 'customer') {
      console.log('customer');
      if (pathsplit[0] === 'p') {
        console.log('opening project...');
      } else if (pathsplit[0] === '') {
        this.page = '';
      } else {
        await this.router.navigateByUrl('/');
      }
    } else {
      if (pathsplit[0] === '') {
        this.page = '';
      }
      if (pathsplit[0].startsWith('compare')) {
        if (!pathsplit[1]) {
          this.page = 'compare';
        }
        if (pathsplit[1]) {
          this.page = 'compareExcel';
        }
      }
      if (pathsplit[0] === 'm') {
        this.page = 'minside';
      }
      if (pathsplit[0] === 'a') {
        if (!pathsplit[1]) {
          this.page = 'admin';
        } else {
          if (pathsplit[1].startsWith('objekttyper')) {
            if (!pathsplit[2]) {
              this.page = 'objekttyper';
            } else {
              if (!pathsplit[3]) {
                this.page = 'objekttype';
              } else {
                if (pathsplit[3] === 'sp') {
                  if (!pathsplit[4]) {
                    this.page = 'sjekklistepunkter';
                  } else {
                    this.page = 'sjekklistepunkt';
                  }
                }
              }
            }
          }
          if (pathsplit[1].startsWith('changelog')) {
            this.page = 'changelog';
          }
          if (pathsplit[1].startsWith('statuses')) {
            this.page = 'statuses';
          }
          if (pathsplit[1].startsWith('kategorier')) {
            this.page = 'kategorier';
          }
          if (pathsplit[1].startsWith('brukere')) {
            if (!pathsplit[2]) {
              this.page = 'brukere';
            }
            if (pathsplit[2]) {
              this.page = 'bruker';
            }
          }
          if (pathsplit[1].startsWith('varsler')) {
            this.page = 'varsler';
          }
          if (pathsplit[1].startsWith('metadata')) {
            this.page = 'metadata';
          }
        }
      }
      if (pathsplit[0] === 'fs') {
        if (pathsplit[2]?.split('?')[0] === 'os') {
          this.page = 'fieldScanObjectSearch';
        } else if (pathsplit[2] === 'o') {
          if (pathsplit[4] === 's') {
            this.page = 'fieldScanChecklist';
          } else {
            this.page = 'fieldScanObject';
          }
        }
      }
    }
  }

  async ngOnInit() {
    this.sharedservice.project.next(null);
    await this.pathHelper(this.currentpathservice.getCurrentpath().path);
    this.sharedservice.navbarVisible.subscribe(visible => {
      this.navbarVisible = visible;
      console.log('Navbar visibility:', this.navbarVisible);
    });
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(async (event: any) => {
        await this.pathHelper(event.url.substring(1).split('/'));
      });

    const firebaseUser = await firstValueFrom(this.userservice.getCurrentUser());

    this.sharedservice.allProjects
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((allProjects) => {
        allProjects.sort(this.sortservice.dynamicSort('no'));
        this.allProjects = allProjects;
        this.fillUser();
      });
    this.userservice.getUser(firebaseUser.uid)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((user) => {
        this.user = user;
        this.sharedservice.user.next(this.user);
        this.fillUser();
      });
  }

  fillUser() {
    if (this.user && this.allProjects) {
      if (this.user?.role?.name === 'admin') {
        this.isAdmin = true;
      }
      if (this.user) {
        const projectsFrontendTemp = [];
        if (this.user.projectaccess) {
          this.allProjects.forEach((project) => {
            this.user.projectaccess.forEach((p) => {
              if (p.id === project.id) {
                projectsFrontendTemp.push(project);
              }
            });
          });
        }
        projectsFrontendTemp.sort(this.sortservice.dynamicSort('no'));
        projectsFrontendTemp.forEach((project) => {
          if (this.user.role?.name === 'customer') {
            project.url = 'p/' + project.id + '/';
          } else {
            project.url = 'p/' + project.id + '/';
          }
        });
        this.projectsFrontend = projectsFrontendTemp;
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  newReceiptform() {
    this.popupservice.openDialogNewReceiptForm(this.user, this.projectid);
  }

  newProject() {
    this.dialogNewProject.open(NewProjectComponent, {
      backdropClass: 'blur-dialog-backdrop',
    });
  }

  logout() {
    this.authservice.logoutConfirm();
  }

  bugReport() {
    this.emailservice.bugReport(this.user);
  }

  reloadVersion() {
    this.globalservice.clearCacheAndRefresh();
  }

  async goHome() {
    console.log('goHome');
    await this.router.navigate(['/']);
  }

}
